import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { UserAppModel } from "@iatec/nephos-layout";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class HttpAppService {
    private http = inject(HttpClient);

    getApps(): Observable<UserAppModel[]> {
        return this.http.get<UserAppModel[]>("./mock/apps.json");
    }
}
